import { ILegenda } from "@deltasge/marauders-map";
import {
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Accordion } from "components/Accordion";
import React, { FC } from "react";

export const AccordionLegendaComponent: FC<{ legendas: ILegenda[] }> = ({
  legendas,
}) => {
  return (
    <Accordion variant="outlined" defaultExpanded>
      <AccordionSummary>
        <Typography variant="subtitle2">Legendas</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Menção</TableCell>
              <TableCell>Descrição</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {legendas.map((legenda, index) => (
              <TableRow hover key={`legenda-${index}-${legenda.id}`}>
                <TableCell>{legenda.nomeAbrev}</TableCell>
                <TableCell>{legenda.nome}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  );
};
